import axios from 'axios';
import { apiKey, apiGetCommentUsers } from '../../config';

export const getCommentUsers = async function(lang){
  let params = {
    apiKey: apiKey,
    token: sessionStorage.athenasToken,
    langCode: lang,
  }
  try {
    const response = await axios.get(apiGetCommentUsers, { params });
    //This response just returns the rules
    if(response.status === 200){
        return response.data;
    }else {
      alert("Something went wrong with getting the file upload rules.");
    }
  } catch(error){
    alert(error.response.data.Messages);
  }
}